"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.graphConnectorTemplates = void 0;
const templateNames_1 = require("../templateNames");
exports.graphConnectorTemplates = [
    {
        id: "graph-connector-ts",
        name: templateNames_1.TemplateNames.GraphConnector,
        language: "typescript",
        description: "",
    },
];
//# sourceMappingURL=graphConnector.js.map